import { createFileRoute } from "@tanstack/react-router";
import { IndustriesIndex } from "./industries";
import { INDUSTRIES } from "@/lib/site";
import { hubItemListNode } from "@/lib/hubSchema";
import { SECTION_OG, sectionImageMeta } from "@/lib/ogSections";
import { hreflangLinks } from "@/lib/hreflang";
import { pageSchemaScript } from "@/seo/schema";

const INDUSTRIES_TITLE = "Industries — Intelligent Environments | Arif Khan";
const INDUSTRIES_DESC =
  "Sector-specific security, automation and AV programs for residences, corporate, hospitality, education, government and industrial clients across India.";

export const Route = createFileRoute("/industries/")({
  component: IndustriesIndex,
  head: () => ({
    meta: [
      { title: INDUSTRIES_TITLE },
      { name: "description", content: INDUSTRIES_DESC },
      { property: "og:title", content: "Industries | Arif Khan" },
      { property: "og:description", content: "Sector-specific intelligent environments — security, automation and AV programs across industries." },
      { property: "og:url", content: "https://arifkhanglobal.com/industries" },
      ...sectionImageMeta(SECTION_OG.industries, "Industries served by Arif Khan — residences, corporate, hospitality, industrial"),
    ],

    links: [
      { rel: "canonical", href: "https://arifkhanglobal.com/industries" },
      ...hreflangLinks("/industries"),
      { rel: "alternate", type: "text/markdown", href: "https://arifkhanglobal.com/industries.md", title: "Markdown mirror" },
    ],
    scripts: [
      pageSchemaScript(
        {
          path: "/industries",
          type: "CollectionPage",
          name: INDUSTRIES_TITLE,
          description: INDUSTRIES_DESC,
          breadcrumb: [{ name: "Industries", url: "/industries" }],
        },
        [
          hubItemListNode({
            hubPath: "/industries",
            listName: "Industries served by Arif Khan",
            items: INDUSTRIES.map((ind) => ({
              name: ind.title,
              url: `/industries/${ind.slug}`,
            })),
          }),
        ],
      ),
    ],
  }),
});
